var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGenericError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--error-icon-background)",
  d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M42.374 105.633 85.17 93.587a6 6 0 0 0 4.15-7.402L74.05 31.933a6 6 0 0 0-2.842-3.607l-11.736-6.58a6 6 0 0 0-4.56-.543l-33.638 9.468a6 6 0 0 0-4.15 7.401l17.849 63.411a6 6 0 0 0 7.4 4.15Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m70.75 97.5-30.836 1.478a5.5 5.5 0 0 1-5.762-5.398L33 27.25l4-1 3.25 53.5 36 16.25z",
  style: {
    mixBlendMode: "overlay"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.452 96.88h52.1a3.45 3.45 0 0 0 3.45-3.45V30.544a3.45 3.45 0 0 0-1.011-2.44L82.397 16.511a3.45 3.45 0 0 0-2.44-1.01H39.452a3.45 3.45 0 0 0-3.45 3.45v74.478a3.45 3.45 0 0 0 3.45 3.45Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "m81.386 15.5 13.615 13.616H84.836a3.45 3.45 0 0 1-3.45-3.45z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BCCEF5",
  d: "M43 27.95a2.45 2.45 0 0 1 2.45-2.45h20.1a2.45 2.45 0 1 1 0 4.9h-20.1A2.45 2.45 0 0 1 43 27.95"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E9EFFC",
  d: "M43 41.85a2.45 2.45 0 0 1 2.45-2.45h41.1a2.45 2.45 0 1 1 0 4.9h-41.1A2.45 2.45 0 0 1 43 41.85m0 13.9a2.45 2.45 0 0 1 2.45-2.45h41.1a2.45 2.45 0 1 1 0 4.9h-41.1A2.45 2.45 0 0 1 43 55.75m0 13.9a2.45 2.45 0 0 1 2.45-2.45h41.1a2.45 2.45 0 1 1 0 4.9h-41.1A2.45 2.45 0 0 1 43 69.65m0 13.9a2.45 2.45 0 0 1 2.45-2.45h41.1a2.45 2.45 0 1 1 0 4.9h-41.1A2.45 2.45 0 0 1 43 83.55"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M82.288 61.117c2.304-4.031 8.116-4.031 10.42 0l19.66 34.407c2.286 4-.602 8.976-5.209 8.976H67.837c-4.607 0-7.495-4.977-5.21-8.977z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M87.479 92.13c1.346 0 2.436 1.069 2.436 2.386v.098c0 1.318-1.09 2.386-2.436 2.386s-2.436-1.068-2.436-2.386v-.098c0-1.317 1.09-2.386 2.436-2.386M87.5 69c1.397 0 2.523 1.12 2.5 2.489l-.258 15.355c-.02 1.198-1.018 2.16-2.242 2.16s-2.222-.962-2.242-2.16L85 71.489C84.977 70.12 86.103 69 87.5 69"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGenericError);
export default ForwardRef;